import React from 'react'
import TopHeader from '../home/TopHeader'
import Breadcrumbs from '../common/Breadcrumbs'
import Footer from '../home/Footer'

export default function PrivacyPolicy() {
    return (
        <div>
            <TopHeader />
            <Breadcrumbs main={"Privacy Policy"} parent={"Privacy Policy"} />
            <div className="container">
                <h4>Privacy Policy – H N Store</h4>
                <p>
                    At <strong>H N Store</strong>, we value the trust of our customers and business partners.
                    This Privacy Policy explains how we collect, use, and protect your personal data when you
                    interact with us through our website, enquiry forms, or while making online purchases.
                </p>

                <h4>Contact Information</h4>
                <p>
                    If you have questions about this Privacy Policy or how your data is handled, please contact us:
                    <br />
                    <strong>Email:</strong> <a href="mailto:hnstoreuser@gmail.com">hnstoreuser@gmail.com</a> <br />
                </p>

                <h4>What personal data do we collect?</h4>
                <p>We may collect the following information when you interact with H N Store:</p>
                <ul>
                    <li>Name, company name and designation</li>
                    <li>Billing and shipping address</li>
                    <li>Phone number</li>
                    <li>Email address</li>
                    <li>Payment details (processed securely via our payment gateway provider)</li>
                    <li>Product interests and enquiry/order details</li>
                    <li>IP address and browser/device information</li>
                </ul>

                <h4>How do we collect your data?</h4>
                <p>Your data is collected when:</p>
                <ul>
                    <li>You place an order or make a payment through our website.</li>
                    <li>You fill out an enquiry form or add products to your cart and submit an enquiry.</li>
                    <li>You contact us by email, phone, or through other communication channels.</li>
                    <li>You engage with us via social media platforms such as LinkedIn, Facebook, or Instagram.</li>
                    <li>Cookies and similar technologies are used when you visit our website (see Cookies section).</li>
                </ul>

                <h4>How do we use your data?</h4>
                <p>We use your personal data for the following purposes:</p>
                <ul>
                    <li>To process your orders and securely handle online payments.</li>
                    <li>To respond to your product enquiries and provide quotations.</li>
                    <li>To communicate about potential business partnerships and supply opportunities.</li>
                    <li>To maintain internal records and business communications.</li>
                    <li>To improve our website, services, and customer experience.</li>
                    <li>To comply with applicable legal, financial, and regulatory requirements.</li>
                </ul>

                <h4>Payment Security</h4>
                <p>
                    Online payments on H N Store are processed through a secure, trusted payment gateway.
                    We do not store your credit/debit card details on our servers. All transactions are encrypted
                    and handled directly by the payment service provider in compliance with PCI-DSS standards.
                </p>

                <h4>Cookies and Website Analytics</h4>
                <p>
                    Our website uses cookies and analytics tools to understand user behavior and improve
                    performance. These tools may collect anonymous information such as IP address, browser type,
                    and pages visited. You can control cookie preferences through your browser settings.
                </p>

                <h4>Data Sharing</h4>
                <p>
                    We do not sell or rent your personal data. We may share your data only with trusted service providers
                    (such as IT, hosting, payment gateway, or communication tools) who assist us in operating our business,
                    and only to the extent necessary. All partners are bound by confidentiality and security obligations.
                </p>

                <h4>International Data Transfer</h4>
                <p>
                    Since H N Store operates globally, your information may be transferred and
                    processed in countries outside your region. We ensure that appropriate safeguards are in place
                    to protect your data in compliance with applicable data protection laws.
                </p>

                <h4>Data Retention</h4>
                <p>
                    We retain your data as long as necessary to fulfill business, legal, and financial obligations.
                    When data is no longer required, it will be securely deleted or anonymized.
                </p>

                <h4>Your Rights</h4>
                <p>You have the right to:</p>
                <ul>
                    <li>Request access to the personal data we hold about you.</li>
                    <li>Request correction of inaccurate or incomplete information.</li>
                    <li>Request deletion of your data, subject to legal or contractual obligations.</li>
                    <li>Withdraw consent where processing is based on consent.</li>
                </ul>
                <p>
                    To exercise your rights, please contact us at
                    <a href="mailto:hnstoreuser@gmail.com"> {" "}hnstoreuser@gmail.com</a>.
                </p>

                <h4>Updates to this Privacy Policy</h4>
                <p>
                    We may update this Privacy Policy from time to time to reflect business, legal, or regulatory changes.
                    Any updates will be posted on this page with the updated effective date.
                </p>
            </div>
            <Footer />
        </div>
    )
}
